import React from "react";
import Reveal from "./Reveal";
import { overview } from "../mock";

const Overview = () => {
  return (
    <section id="overview" className="bg-neg-beige py-20 lg:py-28">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal>
          <div className="flex flex-col items-center">
            <h2 className="font-display text-neg-navy text-4xl sm:text-5xl text-center">
              {overview.title}
            </h2>
            <span className="mt-5 h-px w-16 bg-neg-gold" />
          </div>
        </Reveal>

        <div className="mt-14">
          {overview.rows.map((row, idx) => (
            <Reveal key={row.label} delay={idx * 70}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-8 py-6 border-b border-neg-gold/30 items-start">
                <div className="text-neg-navy text-lg font-medium">{row.label}</div>
                <div className="sm:text-right space-y-1.5">
                  {row.values.map((v, i) => (
                    <p key={i} className="text-neg-navy/70 leading-relaxed">
                      {v}
                    </p>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Overview;
